import '../styles/WhyBularis.css';

const values = [
  {
    title: 'Built Around Business Needs',
    description: 'We start with the operational or digital problem, then shape the technology around what the business actually needs.',
  },
  {
    title: 'Technical Depth',
    description: 'Our work spans web applications, e-commerce, Shopify, APIs, payment integrations, and business automation.',
  },
  {
    title: 'End-to-End Thinking',
    description: 'We consider the complete workflow—from user experience and integrations to deployment and continued improvement.',
  },
  {
    title: 'Built for What Comes Next',
    description: 'Solutions are planned with future growth, connected systems, and further automation in mind.',
  },
];

const WhyBularis = () => {
  return (
    <section className="why-bularis">
      <div className="why-bularis-container">
        <header className="why-bularis-intro">
          <span>How we think</span>
          <h2>Why Bularis Tech</h2>
          <p>
            Good technology should fit the business, connect the right workflows, and remain
            useful as priorities evolve.
          </p>
        </header>

        <div className="why-bularis-values">
          {values.map((value, index) => (
            <article className="why-bularis-value" key={value.title}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBularis;
